import React from 'react'
import SubAdmin from '../masterLayout/SubAdmin'
import Breadcrumb from '../components/Breadcrumb'
import ManagerTeamList from '../components/child/ManagerTeamList'

const ManagerList = () => {
  return (
        <SubAdmin>
        <Breadcrumb title="Manager List" />
        <ManagerTeamList />
    </SubAdmin>
  )
}

export default ManagerList